import Layout from '@/layout';
export default {
  path: '/careerPlan',
  component: Layout,
  redirect: '/careerPlan/config',
  name: 'CareerPlan',
  alwaysShow: true,
  meta: {
    title: 'AI职业规划',
    icon: 'clipboard'
  },
  children: [{
    path: 'config',
    component: function component() {
      return import('@/views/careerPlan/config');
    },
    name: 'CareerPlanConfig',
    meta: {
      title: '功能配置'
    }
  }, {
    path: 'prompts',
    component: function component() {
      return import('@/views/careerPlan/prompts');
    },
    name: 'CareerPlanPrompts',
    meta: {
      title: '提示词版本'
    }
  }, {
    path: 'monitor',
    component: function component() {
      return import('@/views/careerPlan/monitor');
    },
    name: 'CareerPlanMonitor',
    meta: {
      title: '生成监控'
    }
  }]
};